import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from '../../nest-responses';


@Injectable()
export class CalendarApi {

    private service: string = '';
    private model: string = 'calendar';

    constructor(
        public nestApiProvider: NestApiProvider,
    ) {
    }

    public getCalendar(payload: { year: number, month: number }): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const func: string = 'getCalendar';
        const params: any = {}
        const urlParams: any = payload
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public getCalendarDetail(payload: { id: string }): Observable<ResponseData<any>> {
        const method: string = 'GET';
        const func: string = 'getCalendarDetail';
        const params: any = {}
        const urlParams: any = payload
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public checkParticipantCalendar(payload: { empIds: any, startDate: any, endDate: any }): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'checkParticipantCalendar';
        const params: any = payload
        const urlParams: any = {}
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public setCalendar(payload: any): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'setCalendar';
        const params: any = payload
        const urlParams: any = {}
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public searchParticipant(payload: { keyword: string }): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'searchParticipant';
        const params: any = payload
        const urlParams: any = {}
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

    public setStatusParticipant(payload: { calendarId: string, status: any, notes: any }): Observable<ResponseData<any>> {
        const method: string = 'POST';
        const func: string = 'setStatusParticipant';
        const params: any = payload
        const urlParams: any = {}
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
    }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/calendar.api.ts